<template>
    <span>
        <a v-if="downloadUrl && !disabled" :href="downloadUrl" class="blue--text" @click.prevent="handleClick">
            {{ fileName }}
        </a>
        <span v-else>{{ fileName }}</span>
    </span>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import downloader from '../../utils/blob_download';

@Component({
    name: 'DownloadLink',
})
export default class DownloadLink extends Vue {
    @Prop({ default: () => '' }) fileName: string;
    @Prop({ default: () => '' }) downloadUrl: string;
    @Prop({ default: false }) disabled: boolean;

    /**
     * methods
     */
    handleClick() {
        /**
         * javascriptによるダウンロード処理は、ブラウザの制限により、クリックイベントのコンテキストでしか実行できない
         * vuexの非同期処理を経由すると、API呼び出しが別のコンテキストで実行されてしまうので、
         * ここでは、vuexを使わず直接APIを呼び出す
         */
        this.$emit('download-start');
        downloader
            .get(this.$store, this.downloadUrl, response => {
                const blob = new Blob([response.data]);

                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, this.fileName);
                } else {
                    let anchor = document.createElement('a');
                    anchor.setAttribute('style', 'display:none;');
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = this.fileName;
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                }
            })
            .then(() => {
                this.$emit('download-success');
            })
            .catch(e => {
                this.$emit('download-failure', e);
            });
        return false;
    }
}
</script>
